export default __webpack_public_path__ + "static/media/Alicia_Tetteh_AHV_In_Moms_We_Trust.f427eb97.jpg";